// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chanLogoImgWrap{width:40px;height:40px;padding:5px;border-radius:100%;display:flex;align-items:center;justify-content:center;border:2px solid #ccc;position:relative;flex-shrink:0}.unfollowBtn{cursor:auto;background-color:#ccc;color:#4a669e}.followBtn,.unfollowBtn{border-radius:5px;padding:5px 10px;font-size:13px;margin-top:.3rem}.followBtn{background-color:#879dc9;color:#fff}", ""]);
// Exports
module.exports = exports;
